// dependencies
import React, { lazy, useEffect, useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import { Disclaimers, PricePoint, defineMessages, TopLegals } from 'ouisys-component-library';
import * as RDS from 'ouisys-engine/dist/common-types/RemoteDataState';
import strategy from 'ouisys-engine/dist/flows/strategy';
import { identifyStrategy, StrategyFlowActionMaps, tracker } from 'ouisys-engine/dist/reducers/strategy';
import {
  IDENTIFYMSISDNEntryFailure,
  IDENTIFYMSISDNEntrySuccess,
  IIdenyifyFlowByMsisdnSumbitNextData
} from 'ouisys-engine/dist/reducers/strategy/StrategyTypes';
import store from 'ouisys-engine/dist/store';
import { IApplicationState } from 'ouisys-engine/dist/store/reducers';
import { setOnLoadUtilities } from 'ouisys-engine/dist/utilities';
import { getConfig } from 'ouisys-phone-input/dist/common/PhoneInput';

// local
import Loader from './components/Loader';
import OperatorSelection from './components/OperatorSelection';
import PhoneNumberEntryStep from './components/PhoneNumberEntryStep';
import SwitchLang from './components/SwitchLang';
import { legals, Translate, TranslationProvider } from './localization/index';
import searchToObject from './utils/searchToObject';
import PreLander from './components/PreLander';
import Click2smsFlow from './flows/Click2smsFlow';
import MoFlow from './flows/MoFlow';
import MoRedirFlow from './flows/MoRedirFlow';
import OneClickFlow from './flows/OneClickFlow';
import PinFlow from './flows/PinFlow';
import UssdFlow from './flows/UssdFlow';
import CreditCardFlow from './flows/CreditCardFlow';
// import './Bloxz.scss';
import './Root.scss';
import { usePinEntryState } from 'ouisys-engine/dist/custom-hooks/usePinEntryState';


//Error messages Messages which might come from backend
const defaultMessages = defineMessages({
  InvalidMSISDN: {
    id: "InvalidMSISDN",
    defaultMessage: "This mobile number is incorrect, try again",
  },
  AlreadySubscribed: {
    id: "AlreadySubscribed",
    defaultMessage: "You are already a subscriber!",
  },
  UnknownError: {
    id: "UnknownError",
    defaultMessage: "An unknown error occurred.",
  },
  InvalidPIN: {
    id: "InvalidPIN",
    defaultMessage: "Please enter the correct PIN that you received on your phone",
  },
  SessionBlocked: {
    id: "SessionBlocked",
    defaultMessage: "Session Blocked!",
  },
  TooEarly: {
    id: "TooEarly",
    defaultMessage: "You must first submit a mobile number",
  },
  didnt_receive_pin_yet: {
    id: "didnt_receive_pin_yet",
    defaultMessage: "Didn't receive PIN yet?"
  }
});


const menu = require("./assets/imgs/menu.svg");
const search = require("./assets/imgs/loop.svg");
const logo = require("./assets/imgs/logo-mobio360.png");
const player = require("./assets/imgs/player.svg");
const play = require("./assets/imgs/play.svg");
const spinner = require("./assets/imgs/spinner1.svg");


const Root = (props: HOCProps) => {

  const [locale, setLocale] = useState<string>("en");
  const [operator, setOperator] = useState<string>(null)
  const [msisdn, setMsisdn] = useState<string>(getConfig(process.env.country).commonPrefix);
  const [skipPrelander, setPrelander] = useState<boolean>(false);
  const [showMsisdn, setShowMsisdn] = useState<number>(1);
  const [hidePlayer, setHidePlayer] = useState<number>(1);
  const [showPlayer, setShowPlayer] = useState<number>(0);

  const dispatch = useDispatch();
  const { currentState } = useSelector((state: IApplicationState) => state.strategy);
  const urlParams = searchToObject();

  const { d_theme, d_locale, d_image } = urlParams as { d_theme: string; d_locale: string; d_image: string; };

  const dImage = d_image ? require(`./assets/imgs/${d_image}.jpg`) : "";


  //Show or hide pre-lander
  const checkSkipPrelander = () => {
    const search = searchToObject();
    if (search["skip-prelander"]) {
      setPrelander((search["skip-prelander"] === "true") ? true : false)
    }
  }

  const autoFillMsisdn = () => {
    const search = searchToObject();
    const phone = search["phone"];
    const isSubmit = search["submit"];
    if (!!phone) {
      setMsisdn(phone)
      if (!!isSubmit && isSubmit === "yes") {
        props.actions.submitMSISDN(
          window,
          null,
          phone,
          null,
          {}
        );
      }
    }
  }



  useEffect(() => {
    dispatch(identifyStrategy())
    checkSkipPrelander();
    autoFillMsisdn();

    //Set locale based on url designer para
    if (d_locale && !!legals[d_locale]) {
      setLocale(d_locale)
    }
  }, [])


  const switchLang = (lang: string) => {
    setLocale(lang)
    if (typeof window != "undefined") {
      document.getElementsByTagName('html')[0].setAttribute("lang", lang)
    }
  }

  const handleShowMsisdn = () => {
    setShowMsisdn(1);
    setHidePlayer(0);
    setShowPlayer(1);
  }


  const divFocus = () => {
    console.log("div focus")
    if (typeof window !== "undefined") {
      document.getElementById("divFocus").className = "shake-horizontal";
      if(document.getElementById("overLay")){
        document.getElementById("overLay").className = "overlay show";

      }
    }
  }


  const identifyFlowByMsisdnInterface = (rds: RDS.RemoteDataState<IDENTIFYMSISDNEntryFailure, IDENTIFYMSISDNEntrySuccess>, nextData: IIdenyifyFlowByMsisdnSumbitNextData) => {
    const { nextAction } = nextData;

    return <PhoneNumberEntryStep
      msisdn={msisdn}
      rds={rds}
      onEnd={(msisdn, bupperNumber, extraParams) => {
        setMsisdn(msisdn);
        dispatch(StrategyFlowActionMaps[nextAction](msisdn))
      }}
      locale={locale}
    />

  }

  return (
    <TranslationProvider locale={locale}>
      <div>

        {/* <SwitchLang locale={locale} switchLang={switchLang.bind(this)} />
        <TopLegals className="top-legals" locale={locale} legals={legals} flow="pin" />
 */}
        {/* can remove this overlay if not needed, this overlay will activated when focus div function is clicked */}
        {/* <div id="overLay" className="overlay hide"></div> */}

        <div className="container guide">
          {/* pre-lander */}
          {
            // !skipPrelander &&
            // <PreLander/>
          }

          {/* Using designer url params example */}

          {
            d_theme == "light" &&
            <div>light theme</div>
          }
          {
            d_theme == "dark" &&
            <div>light theme</div>
          }

          <div className="creativeArea" onClick={divFocus}>
            <div id="playerWrap" className="container">
              <div className={"direction " + (locale === "ar" ? "ar-direction" : "")}>

                <div className="header" onClick={handleShowMsisdn}>
                  <div id="logoImg" className="logo" onClick={() => { tracker.advancedInPreFlow("logo-clicked"); }}>
                    <img src={logo} />
                  </div>
                  <div id="searchIcon" className="search" onClick={() => { tracker.advancedInPreFlow("search-clicked"); }}>
                    <img src={search} />
                  </div>
                  <div id="menuIcon" className="menu" onClick={() => { tracker.advancedInPreFlow("menu-clicked"); }}>
                    <img src={menu} />
                  </div>
                </div>

                <div className={" " + (hidePlayer === 1 ? "active" : "hidden")}>
                  <div className={"player " + (locale === "ar" ? "ar-direction" : "")} onClick={handleShowMsisdn}>
                    <p className="player-title"><Translate id="watch" defaultMessage="Watch " /><span className="red">&nbsp;<Translate id="hd" defaultMessage="- HD 1080p" /></span></p>
                    <img id="videoPlayer" onClick={() => tracker.advancedInPreFlow("video-player-clicked")} className="player" src={player} />
                    <img id="spinner" className="loader" src={spinner} />
                    {/* <img id="play" className="play" src={play} onClick={() => { tracker.advancedInPreFlow("playIcon-clicked"); }} /> */}
                  </div>
                </div>

                <div className={" " + (showPlayer === 1 ? "active" : "hidden")}>
                  <div className={"player " + (locale === "ar" ? "ar-direction" : "")}>
                    <p className="player-title"><Translate id="watch" defaultMessage="Watch " /><span className="red">&nbsp;<Translate id="hd" defaultMessage="- HD 1080p" /></span></p>
                    <img id="videoPlayerSpinner" className="player" src={player} />
                    <img id="spinner" className="loader" src={spinner} />
                  </div>
                </div>

                <div className="btn-container" onClick={handleShowMsisdn}>
                  <div id="watchBtn" onClick={() => tracker.advancedInPreFlow("watch-button-clicked")} className="stream btn-custom"><Translate id="watch-2" defaultMessage="Watch" /></div>
                  <div id="downloadBtn" onClick={() => tracker.advancedInPreFlow("download-button-clicked")} className="download btn-custom" ><Translate id="download" defaultMessage="Download" /></div>
                </div>


              </div>


            </div>
          </div>

          <div onClick={(ev) => ev.stopPropagation()} className="subscriptionAreaWrapper">
            <div className={"show-msisdn msisdn-box fade-in " + (showMsisdn === 1 ? "active" : "hidden")}>

              <div className="msisdn-container">
                <div className="tqmain">

                  {

                    strategy({
                      identifyFlowByOperatorSelect: data => {
                        return <OperatorSelection {...data} setOperator={setOperator} />
                      },
                      identifyFlowByMsisdn: (rds, nextData) => identifyFlowByMsisdnInterface(rds, nextData),
                      pinFlow: nextData => {
                        return <PinFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      },
                      moFlow: nextData => {
                        return <MoFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      },
                      moRedirFlow: nextData => {
                        return <MoRedirFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      },
                      oneClickFlow: nextData => {
                        return <OneClickFlow
                          nextData={nextData}
                          locale={locale}
                          operator={operator}
                        />
                      },
                      click2smsFlow: nextData => {
                        return <Click2smsFlow
                          nextData={nextData}
                          locale={locale}
                          operator={operator}
                        />
                      },
                      ussdFlow: nextData => {
                        return <UssdFlow
                          nextData={nextData}
                          locale={locale}
                          msisdn={msisdn}
                          operator={operator}
                          setMsisdn={setMsisdn}
                        />
                      }

                    })
                      (currentState)
                    //(mockedPinFlow.currentState)
                    // (mockedMoFlow.currentState)
                    // (mockedMoRdirFlow.currentState)
                    // (mockedOneClickFlow.currentState)
                    // (mockedClick2smsFlow.currentState) 
                  }

                </div>
              </div>
            </div>
          </div>

          {
            RDS.WhenLoading(null, () => <div>
              <Loader />
              <div>Please wait...</div>
            </div>)(currentState.result)
          }
          <div className="legalArea">
            {/* disclaimers */}
            <Disclaimers className="disclaimer" locale={locale} legals={legals} />

          </div>
        </div>
      </div>
    </TranslationProvider>
  );
}

const R = () => <Provider store={store}><Root /></Provider>

export default R;




